import "../vendor/@formatjs/intl-durationformat/should-polyfill.js";
import { ref as r } from "vue";
import "@vueuse/core";
r("en");
r([]);
